import type { ButtonProps as Props } from './types';
import type { MouseEvent } from 'react';
import { cls } from '@/utils/cls';
import { useColorProvider } from '@/utils/ColorProvider';
import style from './Button.module.scss';
export default function Button({
  extendStyles,
  copy,
  color,
  arrow,
  href = '#form',
  buttonAlignment,
  textColor,
  usePageColors,
  scrollTo,
  hover,
  wideButton
}: Props) {
  const buttonAlignmentClass = buttonAlignment?.toLowerCase();
  const _className = cls(style.root, extendStyles, style[buttonAlignmentClass], !!hover ? style.hoverColor : '', wideButton && style.wide);
  const {
    colors
  } = useColorProvider();
  const _backgroundColor = usePageColors ? colors.secondaryAccentColor : color;
  function smoothScroll(e: MouseEvent<HTMLElement>) {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({
      behavior: 'smooth'
    });
  }
  return <a className={_className} href={href} style={{
    backgroundColor: _backgroundColor,
    color: textColor,
    '--hover-color': hover
  } as React.CSSProperties} onClick={scrollTo ? e => smoothScroll(e) : undefined} data-sentry-component="Button" data-sentry-source-file="Button.tsx">
			{copy}
			{!!arrow && <svg className={style.icon} viewBox="0 0 20 20" role="presentation">
					<path d="M2 10L18 10" />
					<path d="M10 2L18 10L10 18" />
				</svg>}
		</a>;
}